import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Collapse, Row, Col
} from 'reactstrap';

import TrackedButton from 'src/components/TrackedButton';
import {
  trackEvent,
  TRACKS_THIRD_ARM,
} from 'src/util/segment-storeless';

import ToggleStep from './ToggleStep';
import styles from './style.module.css';
import mobileAppImage from '../assets/mobile-download.png';

const MobileStep = (props) => {
  const { isComplete, getSegmentProps } = props;
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    if (!isOpen && isComplete) {
      trackEvent(
        TRACKS_THIRD_ARM.see_step_again,
        getSegmentProps({
          step_name: 'mobileapp'
        })
      );
    }
    setIsOpen(!isOpen);
  };
  const collapseStyles = isOpen ? styles.stepCollapse : null;

  const onContinueBtn = () => {
    // Find next step and toggle it open, but only if it's closed
    try {
      const nextStep = document.querySelector('[data-test="step-number-3"]').parentElement.nextSibling;
      const nextStepContent = nextStep.querySelector('.collapse');

      if (!nextStepContent.classList.contains('show')) {
        nextStep.querySelector('button').click();
      }
    } catch {}

    // Close this step
    toggle();
  };

  return (
    <div>
      <ToggleStep
        isOpen={isOpen}
        toggle={toggle}
        stepNumber="3"
        stepTitle="Download the mobile app & log into your account"
        isCompleted={isComplete}
      />
      <Collapse className={collapseStyles} isOpen={isOpen} data-test="mobile-app-step-toggle">
        <Row>
          <Col sm={8}>
            <p>
              Our mobile app allows you to trigger, acknowledge, and resolve incidents.
            </p>
            <p>
              Once you&apos;ve downloaded it, sign into your account and get advanced response
              automation at your fingertips.
            </p>
            <p>
              You can configure your profile, customize your ringtones and set behavior for high
              and low urgency incidents from your settings page.
            </p>
            <p className="text-center">
              <TrackedButton
                color="primary"
                size="sm"
                data-test="mobile-app-continue"
                onClick={onContinueBtn}
                trackName={TRACKS_THIRD_ARM.mobile_app_continue}
                trackProperties={getSegmentProps()}
              >
                Continue
              </TrackedButton>
            </p>
          </Col>
          <Col sm={4}>
            <img className={styles.mobileAppDownload} align="right" alt="placeholder" src={mobileAppImage} />
          </Col>
        </Row>
      </Collapse>
    </div>
  );
};

MobileStep.propTypes = {
  isComplete: PropTypes.bool.isRequired,
  getSegmentProps: PropTypes.func.isRequired,
};

export default MobileStep;
